<div class="box">
  <div class="box-header p-3">
    <div class="row">
      <div class="col-md-6">
        <table class="table col-sm-12">
          <tbody>
          <tr>
            <td class="font-weight-bold colon">
              Store #
            </td>
            <td>1234</td>
          </tr>
          <tr>
            <td class="font-weight-bold colon">
              DC Location
            </td>
            <td>Matrix Logistics DC 50</td>
          </tr>
          <tr>
            <td class="font-weight-bold colon">
              OC #
            </td>
            <td>0123456799-PO</td>
          </tr>
          <tr>
            <td class="font-weight-bold colon">
              OC Date
            </td>
            <td>2020-07-08 7:44 PM</td>
          </tr>
          <tr>
            <td class="font-weight-bold colon">
              Status
            </td>
            <td>Pending</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6 text-right">
        <button mat-raised-button>Back to Summary</button>
      </div>
    </div>
  </div>
  <div class="box-body">
    <app-table></app-table>
  </div>
  <div class="box-footer text-right px-3 py-2">
    <button mat-raised-button color="primary">Approve</button>
  </div>
</div>
